import { Record as RARecord } from 'ra-core'
import { TEntityOverrideView } from 'src/types'

export const transform =
  ({ properties }: { properties: TEntityOverrideView['properties'] }) =>
  (srcRecord: RARecord): RARecord => {
    const record: Partial<RARecord> = {}

    Object.keys(srcRecord).forEach(key => {
      const property = properties?.[key]
      const value = srcRecord[key]
      const type = property?.type

      if (type !== 'number' && type !== 'integer') {
        record[key] = value
        return
      }

      const required = property?.required ?? false
      if (value == null && !required) return

      record[key] = value
    })

    return record as RARecord
  }
